import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/store";
import {
  onLoadJuzgados,
  onLoadRegiones,
  onJuzgadoSelected,
  onLoadJuzgadosFilter,
  onResetState,
} from "store/juzgadoConExpediente/juzgadoConExpedienteSlice";
import { Region } from "../../interfaces/demandas/demandasInterface";
import { JuzgadoInterface } from "interfaces/juzgadosConExpediente/juzgadosConExpedinte";
import {
  getJuzgadosConExpediente,
  getRegionesJuzgados,
} from "services/consultaJuzgadosService/consultaJuzgadosService";
import { setIsLoading } from "store";

export const useJuzgadosConExpediente = () => {
  const dispatch = useDispatch();
  const { lstJuzgados, lstRegiones, juzgadoSelected, filterJuzgados } =
    useSelector((state: RootState) => state.juzgadosConExpediente);

  const startGetJuzgados = async () => {
    dispatch(setIsLoading(true));
    try {
      const { data } = await getJuzgadosConExpediente();
      const d = data.data
        .sort(
          (a: JuzgadoInterface, b: JuzgadoInterface) =>
            a.CveRegion - b.CveRegion
        )
        .map((juzgado: JuzgadoInterface) => {
          const region = lstRegiones.find(
            (region: Region) => region.CveRegion === juzgado.CveRegion
          );
          return {
            ...juzgado,
            DesRegion: region?.NomRegion,
          };
        });
      dispatch(onLoadJuzgados(d));
    } catch (error) {
      console.log(error);
    }
    dispatch(setIsLoading(false));
  };

  const startGetRegiones = async () => {
    try {
      const { data } = await getRegionesJuzgados();
      dispatch(onLoadRegiones(data.data));
    } catch (error) {
      console.log(error);
    }
  };

  const addFilterJuzgados = (terminoBusqueda: string) => {
    if (terminoBusqueda) {
      const filter = lstJuzgados.filter((juzgado) => {
        const DesJuz = juzgado.DesJuz.toLowerCase();
        //const region = juzgado.DesRegion.toLowerCase();
        return DesJuz.includes(terminoBusqueda.toLowerCase());
      });
      dispatch(onLoadJuzgadosFilter(filter));
      return;
    }
    dispatch(onLoadJuzgadosFilter(lstJuzgados));
  };

  // order asc or desc Juzgados
  const oderFilterJuzgados = (order: string, key: "DesRegion" | "DesJuz") => {
    if (order === "asc") {
      const filter = filterJuzgados
        .slice()
        .sort((a: JuzgadoInterface, b: JuzgadoInterface) => {
          if (a[key] < b[key]) {
            return -1;
          }
          if (a[key] > b[key]) {
            return 1;
          }
          return 0;
        });
      dispatch(onLoadJuzgadosFilter(filter));
      return;
    }
    const filterDesc = filterJuzgados
      .slice()
      .sort((a: JuzgadoInterface, b: JuzgadoInterface) => {
        if (a[key] < b[key]) {
          return 1;
        }
        if (a[key] > b[key]) {
          return -1;
        }
        return 0;
      });
    dispatch(onLoadJuzgadosFilter(filterDesc));
  };

  const addJuzgadoSelected = (juzgado: JuzgadoInterface) =>
    dispatch(onJuzgadoSelected(juzgado));

  const resetStateJuzgadoExp = () => dispatch(onResetState())

  return {
    // Propiedades
    lstJuzgados,
    lstRegiones,
    juzgadoSelected,
    filterJuzgados,
    // Metodos
    startGetJuzgados,
    startGetRegiones,
    addJuzgadoSelected,
    addFilterJuzgados,
    oderFilterJuzgados,
    resetStateJuzgadoExp
  };
};
